import { Outlet, useNavigate } from 'react-router';
import Logo from '../../assets/icons/logo-b.svg';
import './AuthLayout.scss';
import { useEffect } from 'react';
import { getAccessToken } from '../../utils';

// Helper function to validate a JWT token
const isValidToken = (token: string): boolean => {
  if (!token || token === 'undefined') return false;
  const parts = token.split('.');
  return parts.length === 3;
};

function AuthLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = getAccessToken();
    if (accessToken && isValidToken(accessToken)) {
      navigate('/');
    }
  }, [navigate]);

  return (
    <>
      <div className='auth-container'>
        <div className='main-logo' >
          <img src={Logo} alt='main logo'  />
        </div>
        <Outlet />
      </div>
    </>
  );
}

export default AuthLayout;
